// Dress Length active
document.addEventListener("click", function (e) {
  if (e.target.classList.contains("length-btn")) {

    let defaultBtn = document.querySelector('.length-btn[data-value="Default"]');

    if (e.target.classList.contains("active") && e.target.dataset.value !== "Default") {
      // ✅ Deselect non-Default button → reactivate Default
      e.target.classList.remove("active");
      if (defaultBtn) defaultBtn.classList.add("active");
      console.log("Selected Length: Default");
    } else if (e.target.dataset.value === "Default") {
      // ✅ Default clicked → deselect all others, activate Default
      document.querySelectorAll(".length-btn").forEach(b => b.classList.remove("active"));
      e.target.classList.add("active");
      console.log("Selected Length: Default");
    } else {
      // ✅ New button clicked → switch active
      document.querySelectorAll(".length-btn").forEach(b => b.classList.remove("active"));
      e.target.classList.add("active");
      console.log("Selected Length:", e.target.dataset.value);
    }

  }
});
document.addEventListener("change", function(e) {
  if (e.target.classList.contains("sleeve-dropdown")) {
    console.log("Selected Sleeve:", e.target.value);
  }
});
document.addEventListener("change", function(e) {
  if (e.target.classList.contains("feeding-zip-checkbox")) {
    
    let value = e.target.checked ? "Yes" : "No";

    console.log("Feeding Zip:", value);
  }
});

// Addon Product Code matches the addon variant

document.addEventListener("DOMContentLoaded", function () {
  let sleeveChanged = false;
  document.addEventListener("change", function (e) {
  if (e.target.classList.contains("sleeve-dropdown")) {
    sleeveChanged = true;
  }
});

  // ✅ Ensure addon product is loaded
  if (typeof addonProduct === "undefined") {
    console.error("Addon product not loaded ❌");
    return;
  }

  console.log("Addon Loaded:", addonProduct);

  // ✅ Build variant map
  let variantMap = {};

  addonProduct.variants.forEach(v => {
    let key = `${v.option1}-${v.option2}-${v.option3}`;
    variantMap[key] = v.id;
  });

  console.log("Variant Map:", variantMap);
  window.variantMap = variantMap;
  // ✅ Get selected values
  function getSelectedValues() {

    let lengthBtn = document.querySelector(".length-btn.active");

let length = lengthBtn
  ? lengthBtn.dataset.value
  : "Default";// ✅ DEFAULT


// ✅ FIX
let sleeveDropdown = document.querySelector(".sleeve-dropdown");

let sleeveValue = sleeveDropdown?.value;

// 🔥 CLEAN FIRST
sleeveValue = sleeveValue ? sleeveValue.trim() : "";

// 🔥 FINAL RULE
let sleeve = sleeveValue ? sleeveValue : "Default";



console.log("FINAL SLEEVE:", `"${sleeve}"`);

    let feedingZip = document.querySelector(".feeding-zip-checkbox")?.checked ? "Yes" : "No";

    return {
      sleeve: sleeve,
      length: length,
      feedingZip:feedingZip
    };
  }
  window.getSelectedValues = getSelectedValues;

  // 🔥 FINAL FIX: Capture phase submit interception
  document.addEventListener("submit", function (e) {

    let form = e.target;

    // only target product form
    if (!form.matches("form[action='/cart/add']")) return;

    console.log("FORM INTERCEPTED EARLY 🔥");

    // ✅ STOP theme default behavior
    e.preventDefault();
    e.stopPropagation();

    let mainVariantId = form.querySelector('input[name="id"]')?.value;
    let quantity = parseInt(document.querySelector('input[name="quantity"]')?.value) || 1;

    let { sleeve, length, feedingZip } = getSelectedValues();

    console.log("VALUES:", sleeve, length, feedingZip);

    // validation
    if (!length || !sleeve) {
      alert("Please select all options");
      return;
    }

    // ✅ Build key
    let key = `${length}-${sleeve}-${feedingZip}`;

    console.log("KEY:", key);

    let addonVariantId = variantMap[key];

    console.log("MATCHED VARIANT:", addonVariantId);

    if (!addonVariantId) {
      console.error("Variant not found ❌");
      alert("Variant not found");
      return;
    }
let sleeveDropdown = document.querySelector(".sleeve-dropdown");
let selectedSize = document.querySelector('input[name="custom_size"]:checked')?.value || "";
let linkId = Date.now().toString();
let orderNote = document.querySelector('textarea[name="properties[Order Note:]"]')?.value || "";
let productName = document.querySelector('.m-product-title, h1.product__title, h1')?.textContent?.trim() || "";
console.log("FORM:", form);
console.log("SELECTED SIZE:", selectedSize);

console.log("SELECTED SIZE:", selectedSize);

console.log("------ DEBUG START ------");
console.log("Dropdown Element:", sleeveDropdown);
console.log("Selected Index:", sleeveDropdown?.selectedIndex);

// 🔥 VERY IMPORTANT
console.log("RAW VALUE:", sleeveDropdown?.value);
console.log("RAW TEXT:", sleeveDropdown?.options[sleeveDropdown.selectedIndex]?.text);

// length check (to detect hidden issues)
console.log("VALUE LENGTH:", sleeveDropdown?.value?.length);

// compare explicitly
console.log("IS DEFAULT (value):", sleeveDropdown?.value === "Default");
console.log("IS DEFAULT (text):", sleeveDropdown?.options[sleeveDropdown.selectedIndex]?.text === "Default");

console.log("------ DEBUG END ------");
    // ✅ Add BOTH items (only once)
    console.log("ADDON PAYLOAD:", addonVariantId, mainVariantId, typeof mainVariantId);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: mainVariantId,
            quantity:quantity,
            properties: {
                "Size": selectedSize,
              "Choose Dress Length": length,
              "Choose Sleeve Type": sleeve,
              "Feeding Zips": feedingZip,
              "Order Note": orderNote,
              "_link": linkId
            }
          },
          {
            id: addonVariantId,
            quantity: quantity,
            properties: {
              "_addon": "true",
              "_link": linkId,
              "Belongs to": "Customization for " + productName
            }
          }
        ]
      })
    })
    .then(res => res.json())
    .then(data => {
      console.log("Added to cart ✅", data);

      // ✅ Open side cart
      // ✅ Refresh cart
document.dispatchEvent(new CustomEvent('cart:refresh'));

// 🔥 Try opening cart (multiple fallbacks)

// Method 1 (Minimog standard)
document.dispatchEvent(new CustomEvent('cart:open'));

// Method 2 (some themes)
document.dispatchEvent(new CustomEvent('cart:toggle'));

// Method 3 (custom element)
const drawer = document.querySelector('cart-drawer');
if (drawer && typeof drawer.open === 'function') {
  drawer.open();
}

// Method 4 (force click on cart icon)
const cartBtn = document.querySelector('[href="/cart"], .m-cart-toggle');
if (cartBtn) {
  cartBtn.click();
}
    })
    .catch(err => {
      console.error("Cart Error ❌", err);
    });

  }, true); // ✅ IMPORTANT: capture phase

});


// Cart Remove main product with addon Product
// document.addEventListener("click", function (e) {
//   let btn = e.target.classList.contains('m-cart-item__remove') ? e.target : e.target.closest('.m-cart-item__remove');
//   if (!btn) return;

//   let cartItem = btn.closest('.m-cart-item');
//   let productId = cartItem?.dataset?.productId;

//   console.log("REMOVE CLICKED, product-id:", productId);

//   // Don't run if user is removing an addon itself
//   if (productId === String(addonProduct.id)) return;

//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       // Find the main item being removed
//       let mainIndex = cart.items.findIndex(item => String(item.product_id) === productId);
//       if (mainIndex === -1) return;

//       let removedItem = cart.items[mainIndex];
//       console.log("REMOVING MAIN:", removedItem.title);

//       // Find the addon right after it (they were added together)
//       let nextItem = cart.items[mainIndex + 1];
//       let updates = {};

//       if (nextItem && String(nextItem.product_id) === String(addonProduct.id)) {
//         updates[nextItem.key] = 0;
//         console.log("✅ REMOVING ADDON (next item):", nextItem.title);
//       } else {
//         // Fallback: find any addon with same product
//         cart.items.forEach(item => {
//           if (
//             String(item.product_id) === String(addonProduct.id) &&
//             item.properties?._addon === "true"
//           ) {
//             updates[item.key] = 0;
//             console.log("✅ REMOVING ADDON (fallback):", item.title);
//           }
//         });
//       }

//       console.log("UPDATES:", JSON.stringify(updates));

//       if (Object.keys(updates).length > 0) {
//         setTimeout(() => {
//           fetch('/cart/update.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ updates })
//           }).then(() => {
//             document.dispatchEvent(new CustomEvent('cart:refresh'));
//             console.log("ADDON REMOVED ✅");
//           });
//         }, 500);
//       }
//     });
// }, true);

// // Quantity Selector in cart
// // Sync addon quantity when main product quantity changes
// document.addEventListener("change", function (e) {
//   let qtyInput = e.target.closest('.m-cart-item input[type="number"], .m-cart-item .m-quantity-input');
//   if (!qtyInput) return;

//   let cartItem = qtyInput.closest('.m-cart-item');
//   let productId = cartItem?.dataset?.productId;

//   // Ignore if it's the addon itself
//   if (productId === String(addonProduct.id)) return;

//   let newQty = parseInt(qtyInput.value);
//   console.log("QTY CHANGED:", productId, "new qty:", newQty);

//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       let updates = {};

//       // Find addon items
//       cart.items.forEach(item => {
//         if (
//           String(item.product_id) === String(addonProduct.id) &&
//           item.properties?._addon === "true"
//         ) {
//           if (item.quantity !== newQty) {
//             updates[item.key] = newQty;
//             console.log("SYNCING ADDON QTY:", item.title, "to", newQty);
//           }
//         }
//       });

//       if (Object.keys(updates).length > 0) {
//         fetch('/cart/update.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ updates })
//         }).then(() => {
//           document.dispatchEvent(new CustomEvent('cart:refresh'));
//           console.log("ADDON QTY SYNCED ✅");
//         });
//       }
//     });
// }, true);

// // Also listen for +/- button clicks
// document.addEventListener("click", function (e) {
//   let qtyBtn = e.target.closest('.m-quantity__button, .m-cart-item__quantity-button, [data-quantity-minus], [data-quantity-plus]');
//   if (!qtyBtn) return;

//   let cartItem = qtyBtn.closest('.m-cart-item');
//   let productId = cartItem?.dataset?.productId;

//   if (!productId || productId === String(addonProduct.id)) return;

//   // Wait for theme to update quantity
//   setTimeout(() => {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         // Find the main product's current qty
//         let mainItem = cart.items.find(item => String(item.product_id) === productId);
//         if (!mainItem) return;

//         let mainQty = mainItem.quantity;
//         let updates = {};

//         cart.items.forEach(item => {
//           if (
//             String(item.product_id) === String(addonProduct.id) &&
//             item.properties?._addon === "true" &&
//             item.quantity !== mainQty
//           ) {
//             updates[item.key] = mainQty;
//             console.log("SYNCING ADDON QTY:", mainQty);
//           }
//         });

//         if (Object.keys(updates).length > 0) {
//           fetch('/cart/update.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ updates })
//           }).then(() => {
//             document.dispatchEvent(new CustomEvent('cart:refresh'));
//             console.log("ADDON QTY SYNCED ✅");
//           });
//         }
//       });
//   }, 600);
// }, true);


// REMOVE: match by _link
// ✅ REMOVE: Clean up orphaned addons after theme removes main item
// ✅ REMOVE: Capture _link FIRST, then clean up addon
document.addEventListener("cart:updated", function (e) {
  setTimeout(() => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        let updates = {};

        // Which _link ids still belong to a real (non-addon) item
        let activeLinks = [];
        cart.items.forEach(item => {
          if (item.properties?._addon !== "true" && item.properties?._link) {
            activeLinks.push(item.properties._link);
          }
        });

        cart.items.forEach(item => {
          // Case 1: addon's main item is gone → remove addon
          if (item.properties?._addon === "true" && item.properties?._link && !activeLinks.includes(item.properties._link)) {
            updates[item.key] = 0;
            console.log("✅ REMOVING ORPHANED ADDON:", item.title);
            return;
          }
          // Case 2: main item still here → keep addon qty matched
          if (item.properties?._addon === "true" && item.properties?._link) {
            let mainItem = cart.items.find(m => m.properties?._addon !== "true" && m.properties?._link === item.properties._link);
            if (mainItem && item.quantity !== mainItem.quantity) {
              updates[item.key] = mainItem.quantity;
              console.log("SYNCING:", item.title, "to", mainItem.quantity);
            }
          }
        });

        if (Object.keys(updates).length > 0) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          }).then(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            console.log("CART SYNCED ✅");
          });
        }
      });
  }, 300);
}, true);


// ✅ ORDERED REMOVE: addon removed first, THEN main product — no timing guesses
document.addEventListener("click", function (e) {
  let btn = e.target.classList.contains('m-cart-item__remove') ? e.target : e.target.closest('.m-cart-item__remove');
  if (!btn) return;

  let cartItem = btn.closest('.m-cart-item');
  let productId = cartItem?.dataset?.productId;
  if (!productId) return;

  if (productId === String(addonProduct.id)) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  // ✅ SHOW LOADING STATE
  btn.disabled = true;                     // stop double-clicks
  btn.style.pointerEvents = "none";
  cartItem.style.opacity = "0.5";
  cartItem.style.position = "relative";

  let spinner = document.createElement("div");
  spinner.className = "addon-remove-spinner";
  spinner.style.cssText = `
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    width: 18px; height: 18px;
    border: 2px solid #ccc; border-top: 2px solid #333;
    border-radius: 50%;
    animation: addon-spin 0.6s linear infinite;
  `;
  cartItem.appendChild(spinner);

  // inject the spin animation once
  if (!document.getElementById('addon-spinner-style')) {
    let style = document.createElement('style');
    style.id = 'addon-spinner-style';
    style.textContent = `@keyframes addon-spin { to { transform: translate(-50%, -50%) rotate(360deg); } }`;
    document.head.appendChild(style);
  }

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      let mainItem = cart.items.find(item =>
        String(item.product_id) === productId && item.properties?._addon !== "true"
      );
      if (!mainItem) return;

      let linkId = mainItem.properties?._link;
      let addonItem = linkId
        ? cart.items.find(item => item.properties?._addon === "true" && item.properties?._link === linkId)
        : null;

      let removeAddon = addonItem
        ? fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [addonItem.key]: 0 } })
          })
        : Promise.resolve();

      removeAddon
        .then(() => {
          console.log("✅ Step 1 done — addon removed:", addonItem?.title || "(none)");
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [mainItem.key]: 0 } })
          });
        })
        .then(res => res.json())
        .then(updatedCart => {
          console.log("✅ Step 2 done — main product removed. Remaining:", updatedCart.item_count);

          document.querySelectorAll('.m-cart-count, .cart-count-bubble, [data-cart-count]').forEach(el => {
            el.textContent = updatedCart.item_count;
          });

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          if (updatedCart.item_count === 0) {
            location.reload();
          }
        })
        .catch(err => {
          console.error("Remove sequence failed ❌", err);
          // ✅ ROLL BACK LOADING STATE on failure so it's not stuck forever
          btn.disabled = false;
          btn.style.pointerEvents = "auto";
          cartItem.style.opacity = "1";
          spinner.remove();
        });
    });

}, true);